import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const CustomeTable = ({ columns = [], data = [], changeFieldValues, type }) => {
    if (!columns && !data && !type && !changeFieldValues) return
    return (
        <div className="card">
            <DataTable
                value={data}
                paginator={false}
                lazy={true}
                size="small"
                resizableColumns={true}
            >
                {columns?.map((col, index) => (
                    <Column
                        key={index}
                        field={col.field}
                        header={col.header}
                        style={{ width: col.width }}
                        body={(rowData, column, index) => changeFieldValues(rowData, column, type, columns)}

                    />
                ))}
            </DataTable>
        </div>
    );
};

export default CustomeTable;
